<template>
    <div >
      <TopBar />
      <el-container>
        <el-container>
          <SideBar />
          <el-main>
            <!-- <h1>学生学习情况</h1> -->
            <div class="left-column">
    <!-- 学生画像 -->
    <div class="profile-container student-portrait">
      <img src="@/assets/logo.png" alt="学生头像">
      <div>
        <h2 class="profile-title">学生画像</h2>
        <p>姓名: XXX</p>
        <p>学号: 12345689</p>
        <p>专业: 计算机科学与技术</p>
        <h3>本学期选修课程：</h3>
        <p>《计算机组成原理》《操作系统》《计算机网络》······</p>
        <!-- <ul class="profile-list">
          <li>《计算机组成原理》</li>
          <li>《操作系统》</li>
          <li>《计算机网络》</li>
        </ul> -->
      </div>
    </div>

    <!-- 学生学情概况 -->
    <!-- <div class="profile-container">
      <h2 class="profile-title">学生学情概况</h2>
      <div class="performance-list">
        <div class="performance-item">云端时长: 11</div>
        <div class="performance-item">讨论次数: 2</div>
        <div class="performance-item">互动次数: 4</div>
        <div class="performance-item">瞌睡次数: 0</div>
        <div class="performance-item">考勤次数: 15</div>
        <div class="performance-item">平均成绩: 91</div>
      </div>
    </div> -->
    <div class="profile-container">
      <h2 class="profile-title">学生学情概况</h2>
      <div class="performance-list">
        <div class="performance-item">
          <div class="performance-value">11</div>
          <div class="performance-label">云端时长</div>
        </div>
        <div class="performance-item">
          <div class="performance-value">2</div>
          <div class="performance-label">讨论次数</div>
        </div>
        <div class="performance-item">
          <div class="performance-value">4</div>
          <div class="performance-label">互动次数</div>
        </div>
        <div class="performance-item">
          <div class="performance-value">0</div>
          <div class="performance-label">瞌睡次数</div>
        </div>
        <div class="performance-item">
          <div class="performance-value">15</div>
          <div class="performance-label">考勤次数</div>
        </div>
        <div class="performance-item">
          <div class="performance-value">91</div>
          <div class="performance-label">平均成绩</div>
        </div>
      </div>
    </div>


    <!-- 学生学情预警 -->
    <div class="profile-container">
      <h2 class="profile-title">学生学情预警</h2>
      <ul class="alert-list">
        <li class="alert-item">张X明 上课无故缺席 风险等级: 中</li>
        <li class="alert-item">张X明 多次不交作业 风险等级: 中</li>
        <li class="alert-item">XXX 上课多次打瞌睡 风险等级: 低</li>
        <li class="alert-item">XXX 测试成绩不佳 风险等级: 低</li>
      </ul>
    </div>
  </div>
          <div class="right-column">
            
            <!-- <h2>各类学习资源情况占比</h2> -->
            <!-- 可视化图表1 -->
            <div class="chart-container1"> 
              <h2>各类学习资源情况占比</h2>
            <div ref="chartDom1" style="width: 500px; height: 300px;"></div>
            </div>
            <div class="chart-container2"> 
            <div ref="chartDom2" style="width: 500px; height: 300px;"></div>
            </div>
          </div>
          </el-main>
        </el-container>
      </el-container>
    </div>
  </template>


<script>
import SideBar from '../components/SideBar.vue';
import TopBar from '../components/TopBar.vue';
import * as echarts from 'echarts';
import {  chartOption1, chartOption2 } from '../chartsConfig'; // 引入数据和配置

export default {
  name: 'HomePage',
  components: {
    SideBar,
    TopBar
  },
  data() {
    return {
      myChart1: null,
      myChart2: null
    };
  },
  mounted() {
    this.initCharts();
  },
  beforeDestroy() {
    this.disposeAllCharts();
  },
  methods: {
    initCharts() {
      this.initChart1();
      this.initChart2();
    },
    initChart1() {
      const chartDom1 = this.$refs.chartDom1;
      if (chartDom1) {
        this.myChart1 = echarts.init(chartDom1);
        this.myChart1.setOption(chartOption1);
      } else {
        console.error('Chart DOM element 1 not found');
      }
    },
    initChart2() {
      const chartDom2 = this.$refs.chartDom2;
      if (chartDom2) {
        this.myChart2 = echarts.init(chartDom2);
        this.myChart2.setOption(chartOption2);
      } else {
        console.error('Chart DOM element 2 not found');
      }
    },
    disposeAllCharts() {
      if (this.myChart1) {
        this.myChart1.dispose();
      }
      if (this.myChart2) {
        this.myChart2.dispose();
      }
      
    }
  }
}
</script>

<style scoped>
/* 页面布局 */
.el-container {
  display: flex;
  /* flex-direction: column; */
  height: 100vh;
}

.el-main {
  display: grid;
  grid-template-columns: 6fr 4fr; /* 左右宽度比例为6:4 */
  /* grid-template-columns: 1fr 1fr; 左右两列布局 */
  gap: 20px;
  background-color: rgb(232, 232, 232);
  padding: 20px;
}

/* 左侧内容区域（学生信息和学情概况） */
.left-column {
  display: grid;
  grid-template-rows: auto auto; /* 两个区域垂直排列 */
  gap: 20px;
}

/* 右侧内容区域（图表） */
.right-column {
  display: grid;
  grid-template-rows: 1fr 1fr; /* 两个图表垂直排列 */
  gap: 20px;
  height: fit-content;
}

/* 学生信息和学情概况区域样式 */
/* .profile-container {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 20px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.profile-title {
  font-size: 18px;
  color: #333;
  font-weight: bold;
  margin-bottom: 10px;

} */

/* 学生学情概况容器样式 */
.profile-container {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 20px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 标题样式 */
.profile-title {
  font-size: 18px;
  color: #333;
  font-weight: bold;
  margin-bottom: 15px;
}

/* 数据项布局和样式 */
.performance-list {
  display: grid;
  grid-template-columns: repeat(6, 1fr); /* 设置为6列 */
  gap: 10px;
  text-align: center;
}

/* 数字样式 */
.performance-value {
  font-size: 24px; /* 数字较大 */
  font-weight: bold;
}
.performance-item:nth-child(1) .performance-value {
  color: #ff5733; /* 第1个数字的颜色 - 橙色 */
}

.performance-item:nth-child(2) .performance-value {
  color: #33c3ff; /* 第2个数字的颜色 - 浅蓝色 */
}

.performance-item:nth-child(3) .performance-value {
  color: #33ff57; /* 第3个数字的颜色 - 绿色 */
}

.performance-item:nth-child(4) .performance-value {
  color: #ff33a1; /* 第4个数字的颜色 - 粉色 */
}

.performance-item:nth-child(5) .performance-value {
  color: #ffd133; /* 第5个数字的颜色 - 黄色 */
}

.performance-item:nth-child(6) .performance-value {
  color: #9b33ff; /* 第6个数字的颜色 - 紫色 */
}

/* 标签文字样式 */
.performance-label {
  font-size: 12px;
  color: #888; /* 灰色 */
}

.student-portrait {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.student-portrait img {
  width: 120px;
  height: 80px;
  border-radius: 50%;
  margin-right: 30px;
}

.performance-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  font-size: 14px;
  color: #666;
  text-align: center;
}

.performance-item {
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 5px;
}

.alert-list {
  display: grid;
  gap: 8px;
}

.alert-item {
  background-color: #ffe4e1;
  padding: 8px;
  border-radius: 5px;
  font-size: 14px;
}

/* 图表容器样式 */
.chart-container1 {
  width: 100%;
  height: 90%;
  padding: 20px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin-top: 5px;
  margin-bottom: 5px;
}
.chart-container2 {
  margin-top: 10px;
  width: 100%;
  height: 100%;
  padding: 20px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin-top: 5px;
  margin-bottom: 5px;
}

/* 响应式布局 */
@media (max-width: 768px) {
  .el-main {
    grid-template-columns: 1fr; /* 小屏幕时单列布局 */
  }

  .student-portrait {
    flex-direction: column;
    align-items: center;
  }

  .student-portrait img {
    margin-bottom: 15px;
  }

  .performance-list {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
